
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Splash from "../pages/splash/page";
import Login from "../pages/login/page";
import Onboarding from "../pages/onboarding/page";
import Permissions from "../pages/permissions/page";
import Home from "../pages/home/page";
import Jobs from "../pages/jobs/page";
import JobDetail from "../pages/job-detail/page";
import ActiveDelivery from "../pages/active-delivery/page";
import Earnings from "../pages/earnings/page";
import Schedule from "../pages/schedule/page";
import Notifications from "../pages/notifications/page";
import Profile from "../pages/profile/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Splash />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/onboarding",
    element: <Onboarding />,
  },
  {
    path: "/permissions",
    element: <Permissions />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/jobs",
    element: <Jobs />,
  },
  {
    path: "/job/:orderId",
    element: <JobDetail />,
  },
  {
    path: "/active-delivery",
    element: <ActiveDelivery />,
  },
  {
    path: "/earnings",
    element: <Earnings />,
  },
  {
    path: "/schedule",
    element: <Schedule />,
  },
  {
    path: "/notifications",
    element: <Notifications />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
